import { Link } from 'react-router-dom';
import { Icon, type TIconName } from '@pu/mpp-ui/components/icon';
import { useCSS } from '@pu/mpp-ui/hooks';

import './side-nav-link.scss';

export type TSubNavLink = Omit<INavLink, 'links'>;
export interface INavLink {
  to?: string;
  action?: () => void;
  label: string;
  icon?: TIconName;
  isActive?: boolean;
  sublinks?: Array<TSubNavLink>;
}

interface ISideNavLinkProps {
  link: INavLink;
  isActive?: boolean;
}

export const SideNavLink = ({ link, isActive = false }: ISideNavLinkProps) => {
  const css = useCSS('sidenav-link');

  return (
    <Link className={css({ active: isActive })} to={link.to || ''}>
      <div className="sidenav-link__icon">
        <Icon name={link.icon || 'globe'} weight={isActive ? 'bold' : 'regular'} />
      </div>
      <p className="sidenav-link__text">{link.label}</p>
    </Link>
  );
};
